// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyAccount_wrapper__C290D","subtitle":"EmptyAccount_subtitle__VwLow","btnWrapper":"EmptyAccount_btnWrapper__+YQ25"};